import { render } from "./AuthenticationVerification.vue?vue&type=template&id=c930c6ca"
import script from "./AuthenticationVerification.vue?vue&type=script&lang=js"
export * from "./AuthenticationVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__